module.exports = __webpack_public_path__ + "static/media/StageTK.09001048.jpg";